"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MealMeatCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MealMeatCircleLinear = function MealMeatCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20zm-1 0c0 10.493-8.507 19-19 19S1 30.493 1 20 9.507 1 20 1s19 8.507 19 19z",
    fill: "#000",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.692 6.365c3.767-2.74 12.817-3.391 17.101 9.461.12.577.252 1.13.379 1.663.618 2.592 1.125 4.717-.375 6.874l2.328 2.752a3.13 3.13 0 112.133 5.848 3.13 3.13 0 01-5.782-2.383l-2.784-3.016c-2.98 1.106-5.62-.386-8.702-2.13a151.28 151.28 0 00-1.002-.563C2.515 18.683 5.925 9.105 9.692 6.365zM25.265 23.9l-2.194 1.828c-1.38.805-2.566.846-3.769.545-1.387-.347-2.778-1.131-4.527-2.118-.333-.188-.679-.383-1.04-.584-4.82-2.854-6.247-6.325-6.235-9.24.012-3.059 1.598-5.678 3.074-6.752 1.521-1.106 4.222-1.842 6.996-.908 2.694.908 5.736 3.496 7.773 9.55.11.518.226 1.013.337 1.477l.032.138c.106.443.204.853.29 1.252.189.882.295 1.606.275 2.261-.024.811-.24 1.633-1.012 2.551zm-1.178 2.965l2.83 3.065.375.407-.278.479a1.63 1.63 0 102.976 1.273l.144-.495.514-.044a1.631 1.631 0 10-1.19-2.873l-.571.48-.483-.57-2.6-3.074a11.458 11.458 0 01-1.716 1.352z",
    fill: "#75787B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 23c.706-1.4 2.122-4.469 5.77-3.536 0 0 3.73 1.072 6.73.536 3-.536 2-5.5 2-5.5",
    stroke: "#75787B",
    strokeWidth: 1.5
  }));
};

exports.MealMeatCircleLinear = MealMeatCircleLinear;
var _default = MealMeatCircleLinear;
exports.default = _default;